const t=t=>{if(!t)return;if(t.includes("localhost"))return"localhost";const n=t.split("."),i=["dev","admin","identity"];for(;n.length>2&&i.includes(n[0]);)n.shift();return n.join(".")};export{t as extractBaseDomain};
//# sourceMappingURL=useDomain.helpers.js.map
